import { withPlugins, domEvents } from '@spon/plugins';
import gsap from 'gsap';

function Accordion({ node, plugins: { addEvents } }) {
	// get all accordions
	const accordions = [...node.querySelectorAll('[data-accordion-item]')];

	// Open accordions that have -is-expanded class
	accordions.forEach(accordion => {
		const $accordionContent = accordion.querySelector(
			'[data-accordion-content]'
		);

		if (accordion.classList.contains('-is-expanded')) {
			gsap.set($accordionContent, { height: 'auto' });
		}
	});

	function onClick(e, $el) {
		e.preventDefault();

		const $accordionWrapper = $el.parentNode;
		const $accordionContent = $accordionWrapper.querySelector(
			'[data-accordion-content]'
		);

		// Close current accordion if clicked self
		if ($el.classList.contains('-is-active')) {
			gsap.to($accordionContent, {
				duration: 0.2,
				height: 0,
				ease: 'Sine.easeInOut',
				onComplete: () => {
					$el.classList.remove('-is-active');
				},
			});
		}

		// Close open accordions
		// const $openAccordions = [
		// 	...node.querySelectorAll('[data-accordion-item].-is-expanded'),
		// ];
		// if ($openAccordions.length > 0) {
		// 	gsap.to('.-is-expanded [data-accordion-content]', {
		// 		duration: 0.2,
		// 		height: 0,
		// 		ease: 'Sine.easeInOut',
		// 		onComplete: () => {
		// 			$openAccordions.forEach($accordion => {
		// 				$accordion.classList.remove('-is-expanded');
		// 			});
		// 		},
		// 	});
		// }

		$el.classList.toggle('-is-active');
		$accordionWrapper.classList.toggle('-is-expanded');

		if ($accordionWrapper.classList.contains('-is-expanded')) {
			// setTimeout(() => {
			// 	const rect = $accordionWrapper.getBoundingClientRect();
			// 	const top = rect.top + document.body.scrollTop;

			// 	gsap.to(window, {
			// 		duration: 1,
			// 		scrollTo: top - 56,
			// 	});
			// }, 310);

			gsap.set($accordionContent, { height: 'auto' });
			gsap.from($accordionContent, {
				duration: 0.2,
				height: 0,
			});
		}
	}

	addEvents({
		'click [data-accordion-btn]': onClick,
	});
}

export default withPlugins(domEvents)(Accordion);


if (module.hot) {module.hot.accept(function(err) {
if (err) {
console.error(err);
}
});
}
